import React from "react";
import "./PlayStats.css";

const PlayStats = () => {
  return (
    <div id="playerStats">
      <h1>Sylvia Yousif</h1>
      <div id="playerStats-lines">
        <span id="playerStats-lines-thick"></span>
        <span id="playerStats-lines-thin"></span>
      </div>
      <h2>Web Developer</h2>
    </div>
  );
};

export default PlayStats;
